import {css} from '../utils.js';

const styles = css`
    .ddk-container .menu-item {
        border-color: ${props => props.theme.border};
    }
`;

export default styles;
